module.exports = __webpack_public_path__ + "img/icons BFr_32.e3581d8c.svg";